/**
 * Formats markdown as expected by ReactMarkdown.
 * We noticed issues with new lines: https://github.com/rexxars/react-markdown/issues/273#issuecomment-495701177.
 * @param text input markdown
 */
export function formatMarkdown(text?: string | null): string | undefined {
  return text?.replace(/\r\n/gi, "  \n");
}
